<script lang="ts" setup>
import { ConnectFlowSurveyModel, ConnectFlowSurveyQuestionAnswerModel } from '@/types';

import { AnnotationIcon } from '@heroicons/vue/outline';

const { surveyCallAnswer, survey } = defineProps({
    surveyCallAnswer: {
        type: Array<ConnectFlowSurveyQuestionAnswerModel>,
        required: true,
    },
    survey: {
        type: Object as () => ConnectFlowSurveyModel,
        required: true,
    },
});
</script>

<template>
    <UiPanel>
        <h3 class="mb-4 flex text-lg font-medium text-blue-900">
            <AnnotationIcon class="mr-1 h-6 w-6" />
            {{ survey?.name }}
        </h3>

        <ul>
            <li v-for="answer in surveyCallAnswer" :key="answer.id" class="text-sm">
                <span class="font-semibold">
                    {{ answer.question.label }} ({{ answer.question.rangeAnswer }}):
                </span>
                {{ answer?.value }}
            </li>
        </ul>
    </UiPanel>
</template>
